import type { LandingStrings } from './en';

export const ja: LandingStrings = {
  header: {
    brandSubtitle: '魔法のお店',
    contact: 'お問い合わせ',
    about: 'ゲームについて',
    language: '言語',
  },
  footer: {
    terms: '利用規約',
    privacy: 'プライバシーポリシー',
    copyright: '{year} {holder}. 無断転載を禁じます。',
  },
  home: {
    heroTitle: 'ポーションと魔法のお店をめぐる、ほのぼの3Dゲーム。',
    heroDescription:
      '魔法のガラクタの中から材料を探して、大鍋でポーションを調合し、自分のお店で売ろう。',
    features: [
      {
        title: '自分だけのボトル',
        desc: '形、フタ、ポーションの色。すてきなボトルほど高く売れるよ。',
      },
      {
        title: '意味のある調合',
        desc: 'ポーションにはそれぞれのレシピがあって、その多くはゲームの中でちゃんと効き目があるよ。',
      },
      {
        title: '続きが気になる物語',
        desc: 'おばあちゃんはのんびり旅行に出かけて、お店をまかせてくれた。そこへ、モレンという名前のカエルが取り分をよこせとやってくる。',
      },
      {
        title: '本当に自分のお店',
        desc: '売り物は、自分の手で調合したものだけ。',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: '近日配信',
    tags: { search: '影をたよりに材料探し', craft: '3Dでポーション調合', shop: '居心地のいいお店' },
  },
  about: {
    title: 'Qevryno について',
    intro: [
      'Qevryno へようこそ！魔法まで手づくりの、ほのぼのポーション調合ゲームだよ。',
      'おばあちゃんはのんびり旅行に出かけて、ふしぎな古いおうちの留守番をたのんでいった。忘れられたレシピに、魔法の材料、そしてぐつぐつ煮える方法をまだ覚えている大鍋。一階には小さなお店があって、いまだれが店番をしているのか、村じゅうが気になっているみたい。',
      'ポーションを調合して、ふわふわの使い魔のお世話をして、すてきなお客さんたちに自分の作品を売ろう。コインをためて、魔法のおうちを飾りつけよう。自分のペースで、せかすタイマーもなし。',
    ],
    whatTitle: 'どんなゲーム？',
    what: [
      'Qevryno は、アイテム探しと錬金術の調合、そして小さなお店の経営シミュレーションがひとつになった、のんびり遊べる3Dパズルゲーム。癒し系・ほっこり系のゲーム、カジュアルなパズル、アイテム探し、ポーションづくりや錬金術、自分だけの魔法のお店の経営——そんなゲームが好きなら、Qevryno はまさにぴったり。',
      'ひとりで遊ぶゲームで、インターネットにつながなくても遊べるよ。ネット接続が必要なのは、購入と、見るかどうか選べるごほうび動画のときだけ。バナー広告やポップアップ広告はなくて、ボーナスがもらえる Google AdMob の短い動画は、自分でタップしたときだけ流れるよ。購入は任意で、ジェムと、中身が見える材料セットがあるよ。近日、iOS と Android で配信予定。対応言語は日本語、英語、ロシア語、スペイン語、ドイツ語、フランス語、オランダ語、イタリア語、ポルトガル語（ブラジル）、ポーランド語、韓国語、繁体字中国語、トルコ語。',
    ],
    doTitle: 'ゲームでできること',
    doList: [
      '魔法の3Dの森の広場で、かくれた材料を探す。どの広場も小さなジオラマみたい。',
      '大鍋で魔法のレシピを調合する：安定剤、メイン材料、時のハーブ、そしてひとさじの色。',
      '自分だけのボトルをデザインする：形、フタ、ポーションの色。すてきなボトルほど高く売れる。',
      '自分のお店を切り盛りする：お客さん、評判、市の日、お願いごと。',
      '物語を追いかける：おばあちゃんはのんびり旅行に出かけてお店をまかせてくれた。でも、モレンという名前のカエルが、取り分をよこせと何度もやってくる。',
      '見つけたものを乳鉢ですりつぶし、ボウルでまぜて、ラメを加える。ミックスごとに、質感も色もちがう。',
      '使い魔にごはんをあげて、お店を飾りつける。',
    ],
    faqTitle: 'よくある質問',
    faq: [
      { q: 'Qevryno は無料？', a: 'うん。ゲームは無料で、お金を払わなくても遊べるよ。購入は任意で、ジェムと材料セットがあるよ。' },
      { q: 'オフラインでも遊べる？', a: 'うん。ゲームそのものはネットにつながなくても動くよ。飛行機の中でも、毛布にくるまったままでも、ポーションを調合しよう。インターネットを使うのは、購入と、見るかどうか選べるごほうび動画のときだけ。' },
      { q: '広告はある？', a: '見るかどうか自分で選べるものだけだよ。バナー広告や、画面の合間に出るポップアップ広告はなし。いくつかの場面で、見たいときだけ短い動画を見て、マナなどのボーナスをもらえる。ゲームの中で、動画を見なければいけない場面はないよ。動画は Google AdMob が配信している。くわしくはプライバシーポリシーを見てね。' },
      { q: '対応プラットフォームは？', a: 'iOS と Android。対応言語は日本語、英語、ロシア語、スペイン語、ドイツ語、フランス語、オランダ語、イタリア語、ポルトガル語（ブラジル）、ポーランド語、韓国語、繁体字中国語、トルコ語だよ。' },
      { q: 'こわかったり、ハラハラしたりする？', a: 'ぜんぜん。やさしい音楽が流れる、のんびりほのぼのしたゲームだよ。失敗してもペナルティはないし、帽子をかぶったねこもいるよ。' },
    ],
  },
  contact: {
    title: 'お問い合わせ',
    subtitle: 'Qevryno についてのご質問、不具合、購入や広告のことなど、メールでお問い合わせください。',
    write: 'メールを送る',
    mailSubject: 'Qevryno: サポート',
    tip: 'お使いの端末と、何が起きたかを書いていただけると、スムーズにお手伝いできます。',
    info: {
      title: '連絡先',
      email: 'メール',
      security: 'セキュリティ',
      legalName: '開発者',
      address: '住所',
    },
    refunds: {
      title: '返金と購入について',
      description: '購入はすべて Apple App Store または Google Play を通して行われます。返金をご希望の場合は、各ストアにお問い合わせください：',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/ja-jp/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=ja',
      link: '返金をリクエストする',
      note: '私たちは直接お支払いを受け付けていないため、返金を行うことはできません。購入したものがゲームに届かない場合は、「設定 → 購入を復元」を開くか、メールでご連絡ください。',
    },
  },
  legal: {
    dataController: 'データ管理者',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: 'この文書は英語・ロシア語・スペイン語でのみ提供しています。以下は英語版です。',
  },
};
